import { Button, DataTable } from '@/components'
import { FlexWrapper } from '@/components/layout/flex/flexWrapper'
import { useAxios } from '@/context/axiosContext'
import { useDialog } from '@/context/dialogContext'
import { NoDataComponent } from '@/pages/bizMgmt/bizMgmt'
import TermsAgreeHistMgmt from '@/pages/terms/agree/termsAgreeHistMgmt'
import { tableStyles } from '@/styles/dataTable/style'
import commonUtils from '@/utils/commonUtils'
import { useEffect, useState } from 'react'
import { TableColumn } from 'react-data-table-component'
import { useLocation, useNavigate } from 'react-router-dom'
import styled from 'styled-components'

export interface DataRow {
  rnum: string
  cmpnyCd: string // 회사코드
  cstId: string // 회원번호
  userId: string // 아이디
  name: string // 이름
  nickName: string // 닉네임
  termsId: string // 약관 ID
  agreeVer: string // 동의 버전
  agreeDate: string // 동의 일자
  agreeYn: string // 동의 여부
  updId: string // 수정자
  updDate: string // 수정일시
  seq: number //순번
}

const TermsAgreeMgmt: React.FC = () => {
  const navigate = useNavigate()
  const axios = useAxios()

  const location = useLocation()
  const memberSearchState = location.state?.memberSearchState

  const [data, setData] = useState<DataRow[]>([])
  const [histData, setHistData] = useState<DataRow[]>([])
  const { showConfirm } = useDialog()

  const columns: TableColumn<DataRow>[] = [
    {
      name: 'No.',
      selector: (row) => row.rnum,
      sortable: true,
      wrap: true,
      cell: (row) => (
        <div style={{ width: '100%', textAlign: 'right' }}>{row.rnum}</div>
      ),
    },
    {
      name: '회원번호',
      selector: (row) => row.cstId,
      sortable: true,
      center: true,
      wrap: true,
      style: {
        cursor: 'pointer',
      },
    },
    {
      name: 'ID',
      selector: (row) => row.userId,
      sortable: true,
      wrap: true,
    },
    {
      name: '이름',
      selector: (row) => row.name,
      sortable: true,
      wrap: true,
    },
    {
      name: '닉네임',
      selector: (row) => row.nickName,
      sortable: true,
      wrap: true,
    },
    {
      name: '약관 ID',
      selector: (row) => row.termsId,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '동의 버전',
      selector: (row) => row.agreeVer,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '동의 일자',
      selector: (row) => commonUtils.formatDate(row.agreeDate),
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '동의 여부',
      selector: (row) => row.agreeYn,
      sortable: true,
      center: true,
      wrap: true,
    },
    {
      name: '수정자',
      selector: (row) => row.updId,
      sortable: true,
      wrap: true,
    },
    {
      name: '수정일시',
      selector: (row) => row.updDate,
      format: (row) => commonUtils.formatDate(row.updDate),
      sortable: true,
      wrap: true,
    },
  ]

  useEffect(() => {
    getTermsAgreeList()
  }, [])

  const getTermsAgreeList = async () => {
    try {
      const response = await axios.get('/termsAgree/list', {
        params: {
          cstId: location.state.cstId,
        },
      })

      const listData = response.data.data?.termsAgreeList

      if (Array.isArray(listData)) {
        setData(listData)
      }
    } catch (error) {
      console.error('Error fetching termsAgree list:', error)
    }
  }

  const handleRowClick = async (row: DataRow) => {
    const clickedTermsId = row.termsId

    try {
      const response = await axios.get('/termsAgree/histList', {
        params: { termsId: clickedTermsId, cstId: location.state.cstId },
      })

      const listData = response.data.data?.termsAgreeHistList

      if (Array.isArray(listData)) {
        setHistData(listData)
      }
    } catch (error) {
      console.error('동의 이력 불러오기 오류:', error)
    }
  }

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          width: '100%',
          marginBottom: '10px',
          alignItems: 'center',
          marginTop: '50px',
        }}
      >
        <p style={{ marginLeft: '20px', fontSize: '20px' }}>약관동의관리</p>
        <FlexWrapper gap="10px">
          <Button
            onClick={() => {
              showConfirm({
                title: `회원관리 화면으로 이동할까요?`,
                onConfirm() {
                  navigate('/memberMgmt', {
                    state: { prevSearchState: memberSearchState },
                  })
                },
              })
            }}
            color="neverbe"
            variant="outlined"
          >
            목록
          </Button>
        </FlexWrapper>
      </div>
      <TableWrapper>
        <DataTable
          columns={columns}
          data={data}
          customStyles={tableStyles}
          pagination={true}
          paginationPerPage={10}
          paginationRowsPerPageOptions={[10, 20, 30, 50, 100, 500]}
          noDataComponent={<NoDataComponent />}
          onRowClicked={handleRowClick}
        />
      </TableWrapper>
      {histData && histData.length > 0 && (
        <TermsAgreeHistMgmt histData={histData} />
      )}
    </>
  )
}

const TableWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 600px;

  .select-red {
    color: red;
  }
  .select-blue {
    color: blue;
  }
  .select-default {
    color: inherit;
  }
  .option-blue {
    color: blue;
  }
  .option-red {
    color: red;
  }
`

export default TermsAgreeMgmt
